import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

// apis
import { fetchSalesCashregister } from '@/apis/aipass'

// components
import { SettingSalesManagerTab } from '@/components/organisms/settings/sales-manager/tab'
import { SettingsLayout } from '@/components/layouts/settings-layout'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { AccountContext } from '@/contexts/account'
import { isScreenReadOnlyForUi } from '@/libs/hotel-pms-permission'

type ContainerProps = {}

export const SettingSalesManagerRegister: React.FC<ContainerProps> = () => {
  const { t } = useTranslation()
  const { permissions, permissionsLoaded, permissionsError } = useContext<any>(AccountContext)
  const isSettingsReadOnly = isScreenReadOnlyForUi(permissions, 'settings', permissionsLoaded, permissionsError)
  const [cashRegisterSetting, setCashRegisterSetting] = useState<number>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const history = useHistory()
  const location = useLocation()

  const _fetchSalesCashregister = async () => {
    setIsLoading(true)
    await fetchSalesCashregister()
      .then(res => {
        setCashRegisterSetting(res?.price)
      })
      .catch(() => {
        console.log(t('Communication failed'))
      })
    setIsLoading(false)
  }

  useEffect(() => {
    _fetchSalesCashregister()
  }, [])

  return (
    <SettingsLayout loading={isLoading}>
      <TabContainer tabComponent={<SettingSalesManagerTab currentTab="Cash register" />}>
        <div css={settingListContainerStyle}>
          <div css={cashRegisterSettingContainerStyle}>
            <p>{t('Starting amount')}</p>
            {cashRegisterSetting && <p>¥{cashRegisterSetting.toLocaleString()}</p>}
          </div>

          <Button
            buttonType={isSettingsReadOnly ? ButtonType.PrimaryDisabled : ButtonType.Secondary}
            isDisabled={isSettingsReadOnly}
            onClick={() => {
              if (isSettingsReadOnly) {
                alert(t('HotelPms.Error.readOnly'))
                return
              }
              history.push({ pathname: '/setting/sales-manager/register/edit', search: location.search })
            }}
            width={75}
            height={32}
            fontSize={12}
          >
            {t('Edit')}
          </Button>
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const settingListContainerStyle = css({
  boxShadow: '0px 0px 6px #0000001A',
  borderRadius: '0 5px 5px 5px',
  background: '#FFF',
  padding: '24px 32px 32px',
  position: 'relative',
  height: 'calc(100% - 45px)',
  display: 'flex',
  justifyContent: 'space-between',
})

const cashRegisterSettingContainerStyle = css({
  p: {
    color: '#272727',
    '&:first-of-type': {
      fontWeight: 'bold',
      fontSize: 16,
      paddingBottom: 16,
    },
    '&:last-child': {
      fontSize: 14,
    },
  },
})
